define([
  "globals",
  "jquery",
  "knockout",
  "js-cookie",
  "format-money"],
function (globals, $, ko, Cookies) {

  "use strict";

  //usage productPrice: field
  //if there is a decimal portion, show two decimal places.  If not, show 0 decimal places.
  ko.bindingHandlers.productPrice = {
    update: function(element, valueAccessor) {
      var value = ko.utils.unwrapObservable(valueAccessor());
      var precision = value !== undefined && value !== null && typeof (value) !== "string" && value % 1 === 0 ? 0 : 2;
      var formattedValue = value !== undefined && value !== null && typeof (value) !== "string" ? value.toFixed(precision) : value;
      ko.bindingHandlers.text.update(element, function() {
        return formattedValue;
      });
    },
    defaultPrecision: 1
  };

    var Dimension = function (minDimension, maxDimension, defaultDimension, queryStringKey, cookieName) {
        var self = this;

        self.minDimension = minDimension;
        self.maxDimension = maxDimension;
        self.serializableValue = undefined;
        self.value = ko.observable();

        self.value.subscribe( function ( newValue ) {
            self.serializableValue = newValue;
        } );

        var constrainValue = function ( newValue ) {
            if (newValue < minDimension) { return minDimension; }
            if (newValue > maxDimension) { return maxDimension; }
            return newValue;
        };

        function persist() {
            if (cookieName) {
                Cookies.set(cookieName, self.value());
            }
        };

        var initialDimension = cookieName ? Cookies.get(cookieName) : undefined;
        var queryDimension = $.getQueryStringValue( queryStringKey );

        // If not from querystring, the merchandising page might have something to say about it
        if ( ( !queryDimension || isNaN( queryDimension ) ) &&
            window.initialSearchState !== undefined ) {
            queryDimension = window.initialSearchState[queryStringKey];
        }

        // Either the querystring or the initialSearchState gave us something.  Better constrain it to make sure it's valid and update our cookie
        if ( queryDimension !== undefined && !isNaN( queryDimension ) && queryDimension != "" ) {
            queryDimension = constrainValue( parseFloat(queryDimension) );
            self.value( queryDimension );

        } else {
            var initialDimension = initialDimension === undefined || initialDimension === 'NaN' ? defaultDimension : initialDimension;

            if ( initialDimension > self.maxDimension ) {
                self.value( maxDimension );
            } else if ( initialDimension < minDimension ) {
                self.value( minDimension );
            } else {
                self.value( initialDimension );
            }
        }

        persist();

        self.valueWhole = ko.computed({
            read:
              function () {
                  return Math.floor(self.value());
              },
            write:
              function (newValue) {
                  if (typeof newValue === "undefined") return;

                  var newValueAsInt = $.tryParseInt(newValue.toString());
                  if (newValueAsInt === undefined) {
                      throw "New value could not be parsed as an int.";
                  }

                  var newValue = newValueAsInt + (self.valueEighths() / 8);
                  self.value(newValue);

                  persist();
              }
        });

        self.valueEighths = ko.computed({
            read:
              function () {
                  return (self.value() % 1) * 8;
              },
            write:
              function (newValue) {
                  if (typeof newValue === 'undefined') return;

                  var newValueAsInt = $.tryParseInt(newValue.toString());
                  if (newValueAsInt === undefined) {
                      throw "New value could not be parsed as an int.";
                  }
                  if (newValueAsInt < 0 || newValueAsInt > 8) {
                      throw "New value must be between 0 and 8.";
                  }

                  self.value(self.valueWhole() + (newValueAsInt / 8));

                  persist();
              }
        });

        self.valueToString = function () {

            var selectedEighthsDimension = ko.utils.arrayFirst(self.getDimensionsEighths, function (item) {
                return self.valueEighths() === item.value;
            } );

            if ( selectedEighthsDimension  != null)
                return self.valueWhole() + ' ' + selectedEighthsDimension.name;
            return self.valueWhole() + ' 0/0';
        };

        // This function is used to return a list of all whole number values from the minimum dimension to the maximum...use for dropdowns and such.
        self.getDimensionsWhole = function () {
            var wholeDimensions = [];
            for (var width = self.minDimension; width <= self.maxDimension; width++) {
                wholeDimensions.push(Math.floor(width));
            }
            return wholeDimensions;
        };

        // This function is used to return a list of all eighth number values from the dimensions...use for dropdowns and such.
        self.getDimensionsEighths = [
          { name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 },
          { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 },
          { name: "3/4", value: 6 }, { name: "7/8", value: 7 }];

        var setValue = function ( newValue ) {
            self.value = newValue;
        };

        self.setValueWhole = function ( newValue ) {

            var newValueAsInt = $.tryParseInt( newValue.toString() );
            if ( newValueAsInt === undefined ) {
                throw "New value could not be parsed as an int.";
            }
            self.serializableValue = newValueAsInt + ( self.valueEighths() / 8 );
            self.value = newValueAsInt + ( self.valueEighths() / 8 );

            if (cookieName) {
                Cookies.set(cookieName, self.value);
            }
        };

        self.setValueEighths = function ( newValue ) {
            var newValueAsInt = $.tryParseInt( newValue.toString() );
            if ( newValueAsInt === undefined ) {
                newValueAsInt = self.findDimensionsEighths( newValue );
                if ( newValueAsInt === undefined ) {
                    throw "New value could not be parsed as an int.";
                }

            }
            if ( newValueAsInt < 0 || newValueAsInt > 8 ) {
                throw "New value must be between 1 and 8.";
            }

            setValue( self.valueWhole() + ( newValueAsInt / 8 ) );

            //persist();
        };


        self.type = 'Dimension';
        self.setType = function(type) {
            self.type = type;
        }

        self.getType = function() {
            return self.type;
        }

        return self;
    };

    var WidthDimension = function (minWidth, maxWidth) {
        var self = this;

        if (minWidth === undefined) { minWidth = 30; }
        if (maxWidth === undefined) { maxWidth = 300; }
        self.dimension = new Dimension( minWidth, maxWidth, globals.defaultDimensions.width, "width", "widthz" );
        self.dimension.setType( 'WidthDimension' );
    };

    var HeightDimension = function (minHeight, maxHeight) {
        var self = this;

        if (minHeight === undefined) { minHeight = 30; }
        if (maxHeight === undefined) { maxHeight = 300; }
        self.dimension = new Dimension(minHeight, maxHeight, globals.defaultDimensions.height, "height", "hghtz");
        self.dimension.setType( 'HeightDimension' );
    };

    var OtherDimension = function (minHeight, maxHeight) {

        var self = this;
        self.dimension = new Dimension(minHeight, maxHeight, 0, "SELECTED_OTHERDIMENSION_STORAGE_KEY", "otherdimension");
    };

    return {
        Dimension: Dimension,
        WidthDimension: WidthDimension,
        HeightDimension: HeightDimension,
        OtherDimension: OtherDimension
    };

});
